"use client";

import { useEffect } from "react";
import clarity from "@microsoft/clarity";

import { getUserFromSession } from "@/helper/user/client";

export function Clarity() {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      process.env.NODE_ENV !== "development" &&
      process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID
    ) {
      clarity.init(process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID);

      const user = getUserFromSession();
      const userId = user?.id;

      if (userId) {
        clarity.identify(userId);
      }
    }
  }, []);

  return null;
}
